import { render, staticRenderFns } from "./sso-setup-details-card.vue?vue&type=template&id=6d32a90b"
import script from "./sso-setup-details-card.vue?vue&type=script&lang=js"
export * from "./sso-setup-details-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports